<template>
  <div class="container">
    <h3>修改手机号</h3>
    <img src="@/assets/icon/icon-success.png" alt />
    <div>修改手机号成功，3s后将跳转至登录页</div>
  </div>
</template>

<script>
import pathConfig from "@/config/requirePath";
export default {
  name: "add",
  data() {
    return {};
  },
  methods: {},
  created() {
    setTimeout(() => {
      window.location.href = pathConfig.loginPath;
    }, 3000);
  }
};
</script>

<style lang="scss" scope>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    margin: 30px 0 15px;
  }
  img {
    margin: 30px;
  }
}
</style>
